import type React from 'react';
import { useRef } from 'react';

import useTimer from '@swf/core/hooks/useTimer';

interface Props {
  children(count: number): JSX.Element;
}

const timeUpdater = (time: number) => time + 1000;

const Counter: React.FC<Props> = (props) => {
  const startTime = useRef(Date.now());
  const count = useTimer({ modifier: timeUpdater, initial: startTime.current });

  return props.children(count);
};

export default Counter;
